<script>
import { format } from "@/libs/date.format.js";
import NewHolidays from "@/components/NewHolidays.vue";
import datesMixins from "@/mixins/datesMixins.js";
import Actions from "../Actions.vue";
import AdvancedCourseHeader from "@/components/AdvancedCourseHeader.vue";

const COURSE_DATES = "courseDates";
const HOLIDAYS = "holidays";

const AddHoliday = {
    name: "AddHoliday",
    components: {
        NewHolidays,
        Actions,
        AdvancedCourseHeader,
    },
    mixins: [datesMixins],
    data() {
        return {
            course: null,
            holidays: [],
        };
    },
    methods: {
        upperFirst(word) {
            if (word === undefined) {
                return "";
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        },
        holidaysUpdated(holidays) {
            this.holidays = holidays;
        },

        prevStep() {
            this.$router.push({ name: "Advanced Add Course" });
        },

        submit() {
            this.$storage.setStorageSync(HOLIDAYS, this.holidays);
            this.$router.push({ name: "Advanced Add Venue" });
        },

        submitEditModal(data) {
            this.course = { ...this.course, ...data };
            this.$storage.setStorageSync(COURSE_DATES, this.course);
            this.checkHolidays();
        },
        checkHolidays() {
            if (this.holidays.length > 0) {
                const holidays = this.holidays.filter((holiday) => {
                    if (holiday.oneDay) {
                        if (new Date(holiday.start.plain) > new Date(this.course.plainStartDate)
                            && new Date(holiday.start.plain) < new Date(this.course.plainEndDate)) {
                            return true;
                        }
                        return false;
                    }

                    if (new Date(holiday.start.plain) > new Date(this.course.plainStartDate)
                        && new Date(holiday.end.plain) < new Date(this.course.plainEndDate)) {
                        return true;
                    }

                    return false;
                });

                this.holidays = holidays;
                this.$storage.setStorageSync(HOLIDAYS, this.holidays);
            }
        },
    },
    computed: {
        getCurrentCourseDates() {
            const startWeekday = this.getWeekdayFromDate(new Date(this.course?.plainStartDate));
            const endWeekDay = this.getWeekdayFromDate(new Date(this.course?.plainEndDate));
            return ` ${startWeekday} ${format(this.course?.plainStartDate, "dS mmmm")} - ${endWeekDay} ${format(this.course?.plainEndDate, "dS mmmm yyyy")}`;
        },

        getDefaultHolidays() {
            return this.holidays;
        },
        getActionText() {
            return this.holidays.length === 0 ? "Skip" : "Next";
        },
    },
    mounted() {
        this.course = this.$storage.getStorageSync(COURSE_DATES) || null;
        this.holidays = this.$storage.getStorageSync(HOLIDAYS) || [];
    },
};

export default AddHoliday;
</script>

<template>
    <div class="new-listing-advanced-flow">
        <div class="row">
            <div class="col-md-12">
                <AdvancedCourseHeader
                    :repetition="`${upperFirst(course?.repetition)} recurrence`"
                    :course-name="course?.courseName"
                    :course-dates="getCurrentCourseDates"
                    :course="course"
                    :hide-edit="true"
                    @submit="submitEditModal"
                />

                <h2 class="top-gap">Holiday</h2>

                <div class="my-3 holidays-question">
                    Are there any dates that {{ course?.courseName }} is not
                    running (e.g. half term or bank holidays)? If not you can skip this step.
                </div>

                <NewHolidays
                    :default-holidays="getDefaultHolidays"
                    :start-date="new Date(course?.plainStartDate)"
                    :end-date="new Date(course?.plainEndDate)"
                    start-holiday-label="Holiday start date (optional)"
                    end-holiday-label="Holiday end date (optional) "
                    @updated="holidaysUpdated"
                />
            </div>
        </div>

        <Actions
            class="fixed-bottom"
            actions-styles="alt-bottom-actions mx-0"
            :full-width="true"
            :show-spacer="true"
            additional-block-class="col-3"
            @prev="prevStep"
            @next="submit"
            :next-button-text="getActionText"
            :margin-top="'margin-top-dates'"
            :disabled="false"
        />
    </div>
</template>

<style scoped>
.top-gap {
    margin-top: 38px;
}

.holidays-question {
    color: #636066;
}

.new-listing-advanced-flow {
    min-height: 850px;
}
</style>
